import clsx from 'clsx';
import { useTranslation } from 'next-i18next/pages';
import Image from 'next/image';
import Link from 'next/link';

import { PaginationSortField } from '@pflegia/types/common/job-position/pagination-sort-field';
import { useJobListSortStore } from '@pflegia/ui/hooks/use-sort';

import SimpleCard from '../simple-card';

export interface AvailableJobCardProps {
  name: string;
  altTextShown?: boolean;
  className?: string;
  itemLink?: ((item: string) => string) | string;
}

const AvailableJobCard: React.FC<AvailableJobCardProps> = ({ name, altTextShown = false, className, itemLink }) => {
  const {
    i18n: { language },
    t,
  } = useTranslation('landingPage', { keyPrefix: 'availableJobs' });
  const { setSort } = useJobListSortStore();
  const translatedName = t(name);
  const altText = altTextShown ? `${translatedName} - ${t(name === 'hospital' ? 'altTextOffers' : 'altText')}` : translatedName;
  const textContent = (
    <SimpleCard className={clsx('grid grid-cols-[90px_auto] items-center gap-2 px-4 py-4 md:w-96 md:p-6', className)}>
      <Image alt={altText} height={90} src={`/assets/care-types/${name}.svg`} style={{ aspectRatio: 1 }} width={90} />
      <h3 className='text-center text-xl font-medium wrap-break-word hyphens-auto md:text-2xl' lang={language}>
        {translatedName}
      </h3>
    </SimpleCard>
  );

  return itemLink ? (
    <Link href={typeof itemLink === 'function' ? itemLink(name) : itemLink} onClick={() => setSort?.(PaginationSortField.Salary)}>
      {textContent}
    </Link>
  ) : (
    textContent
  );
};

export default AvailableJobCard;
